import {useOperatorzy} from "../../../api/domain/osoby/queries/useOperatorzy.jsx";
import {SimpleTable} from "../../common/simpleTable/SimpleTable.jsx";
import {listaosobColumns} from "./lib/columns/listaOsobColumns.js";
import ButtonWithIcon from "../../common/ButtonWithIcon.jsx";
import {Icons} from "../../common/Icons.jsx";
import {ModalEdytujOsobe, ModalZarzadzajZastepstwo} from "./lib/modals.jsx";
import {useState} from "react";
import {HeaderTitle} from "../../common/HeaderTitle.jsx";

const ViewOsobyList = () => {

    const osoby = useOperatorzy();
    const [currPozycja, setCurrPozycja] = useState(null)
    const [modalState, setModalState] = useState({
        dodajEdytuj: false,
        zastepstwo: false,
    })


    const modals = () => <>
        <ModalEdytujOsobe
            show={modalState.dodajEdytuj}
            handleClose={() => setModalState(prev => ({...prev, edytuj: false}))}
            currPozycja={currPozycja}
        />
        <ModalZarzadzajZastepstwo
            show={modalState.zastepstwo}
            handleClose={() => setModalState(prev => ({...prev, zastepstwo: false}))}
            currPozycja={currPozycja}
        />
    </>


    const handleEdit = (row) => {
        setCurrPozycja(row)
        setModalState(prev => ({...prev, edytuj: true}))
    }

    const handleManageKierownik = (row) => {
        setCurrPozycja(row)
        setModalState(prev => ({...prev, zastepstwo: true}))
    }

    const td = (row) => {
        return <td>
            <div className={'d-flex gap-1'}>
                <ButtonWithIcon
                    title={'Edytuj'}
                    icon={<Icons.edit/>}
                    onClick={() => handleEdit(row)}
                />
                <ButtonWithIcon
                    variant={row.czy_manager === "Tak" ? 'warning' : 'success'}
                    title={row.czy_manager === "Tak" ? 'Odbierz zastępstwo' : 'Nadaj zastępstwo'}
                    icon={<Icons.addToGroup/>}
                    onClick={() => handleManageKierownik(row)}
                />
            </div>
        </td>
    }
    return (
        <>
            {modals()}
            <HeaderTitle
                title={'Lista osób'}
                size={'h2'}
                nav
                destination={'/'}
            />

            <SimpleTable
                data={osoby.data}
                addTh={() => <th>Operacje</th>}
                addTd={td}
                columns={listaosobColumns}
            />
        </>
    )
}

export default ViewOsobyList